import { useState } from 'react';

import { DialogDescription, DialogTitle } from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Dialog, { DialogContent } from '@/components/Dialog';
import Input from '@/components/Input';
import { cn } from '@/utils';

function PasswordModal({
	open,
	loading,
	invalidPassword,
	onOpenChange,
	onSubmit
}) {
	const [value, setValue] = useState('');

	const { t } = useTranslation();

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="px-5 py-10 md:w-[600px] md:px-8">
				<form
					onSubmit={event => {
						event.preventDefault();
						onSubmit(value);
					}}
					className="grid gap-6"
				>
					<DialogTitle
						className={cn(
							'text-lg text-gray-700',
							invalidPassword && 'text-red-500'
						)}
					>
						{invalidPassword
							? t('editor.passwordModal.invalidPassword')
							: t('editor.passwordModal.title')}
					</DialogTitle>
					<VisuallyHidden asChild>
						<DialogDescription>
							{t('editor.passwordModal.title')}
						</DialogDescription>
					</VisuallyHidden>
					<Input
						type="password"
						onChange={event => setValue(event.target.value)}
					/>
					<div className="grid grid-cols-2 justify-center gap-4 pt-4">
						<Button variant="outline" onClick={() => onOpenChange(false)}>
							{t('common.cancel')}
						</Button>
						<Button type="submit" loading={loading} disabled={!value}>
							{t('common.open')}
						</Button>
					</div>
				</form>
			</DialogContent>
		</Dialog>
	);
}

export default PasswordModal;
